import { Record, List } from 'immutable';

export const PracticeEfectors = new Record({
  id: null,
	isNew: true,
	isPending: false,
  filters: null,
	items: new List(),
  total: 0,
	created_at: new Date(),
});
